import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=76af41ce&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=76af41ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af41ce",
  null
  
)

export default component.exports